import { getDefaultExportFromCjs } from "./auth-service-tools157.js";
import { _ as _baseIsEqual } from "./auth-service-tools458.js";
var baseIsEqual = _baseIsEqual;

function isEqual(value, other) {
  return baseIsEqual(value, other);
}

var isEqual_1 = isEqual;

const _isEqual = /* @__PURE__ */getDefaultExportFromCjs(isEqual_1);

export { _isEqual as default };